import React from 'react';
import { Button, ButtonSize, ButtonVariant } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { Container, Summary } from './CalendarSummary.styles';

export interface CalendarSummaryProps {
  isSameDates: boolean;
  onResetClick: () => void;
  onConfirmClick: () => void;
}

export const CalendarSummary = ({
  isSameDates,
  onResetClick,
  onConfirmClick,
}: CalendarSummaryProps) => {
  const { translations } = useTranslations();

  const resetDatesLabel = i18n('search.dates.reset', [], translations);
  const confirmDatesLabel = i18n('common.date.confirm', [], translations);

  return (
    <Container data-testid="calendar-summary">
      <Summary>
        <Button
          fullWidth={true}
          dataAttributes={{ testid: 'summary-reset-dates' }}
          variant={ButtonVariant.secondary}
          size={ButtonSize.medium}
          onClick={onResetClick}
        >
          {resetDatesLabel}
        </Button>
        <Button
          fullWidth={true}
          dataAttributes={{ testid: 'summary-confirm-dates' }}
          variant={ButtonVariant.primary}
          onClick={onConfirmClick}
          disabled={isSameDates}
        >
          {confirmDatesLabel}
        </Button>
      </Summary>
    </Container>
  );
};
